module.exports = __webpack_public_path__ + "img/bg_function01_1_d.49e66e3e.png";